// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__yUSYT","calendarButtons":"ClockData_calendarButtons__3hBEz"};